export function getI18nJsonProp<
  O extends Record<string, unknown>,
  P extends keyof O,
>(obj: O, prop: P): O[P];
export function getI18nJsonProp(
  obj: Record<string, unknown>,
  prop: string,
): object;
export function getI18nJsonProp(obj: Record<string, unknown>, prop: string) {
  return prop in obj ? obj[prop] : {};
}
